package one.healthium.domain.user.models

import one.healthium.domain.common.FoodUnit
import kotlin.time.Instant

data class FoodOptions(
    val date: Instant,
    val amount: Float,
    val name: String,
    val isLiquid: Boolean,
    val calories: Float,
    val fat: Float,
    val carbohydrates: Float,
    val fiber: Float,
    val protein: Float,
    val tablespoon: Float?,
    val cups: Float?,
    val pieces: Float?,
    val portion: Float?,
    val unit: FoodUnit,
)
